import styled from 'styled-components';

export const GlossaryContainer = styled.div`
  width: 100%;
  height: 100%;
  grid-row: 2/4;
  display: flex;
  flex-direction: column;
  padding: 60px 50px;
  row-gap: 30px;
`;

export const EntriesContainer = styled.div`
  display: flex;
  gap: 30px;
`;

export const ColumnContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const GroupContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const GroupTitle = styled.h2`
  margin-top: 0;
  font-size: 14px;
  color: #222;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
`;

export const GlossaryItem = styled.div`
  margin-bottom: 10px;
`;

export const GlossaryTitle = styled.h3`
  margin: 0;
  font-size: 12px;
  color: #333;
`;

export const GlossaryDescription = styled.p`
  margin: 5px 0 0;
  font-size: 0.8rem;
  color: #666;
`;
